import Vue from "vue";

export const collapseChildJSReactive = Vue.observable({ value: [] });

export default {
  get() {
    return collapseChildJSReactive.value;
  },
  set(active) {
    collapseChildJSReactive.value = active;
  },
};
